<!-- =============================================================================================== -->
<template>
  <div>
    <div class="col-12">
      <div class="card mb-4">
        <span class="top-actions">
          <button
            type="button"
            class="mycustom-success-button"
            data-bs-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-bs-target="#createRequisitionModal"
          >
            <i class="bi bi-plus-square-dotted"></i> Create Category
          </button>
        </span>
      </div>
    </div>
  </div>
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Category Name
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Actions
      </th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <h6 class="mb-0 text-sm">{{ user.category_name }}</h6>
        </td>
        <td class="align-middle">
          <button
            class="btn btn-sm btn-danger"
            @click="deleteCategory(user.id)"
          >
            <i class="bi bi-trash"></i> Delete
          </button>
        </td>
      </tr>
    </template>
  </BaseLayout>
  <!-- Add Category Modal -->
  <div
    class="modal fade"
    id="createRequisitionModal"
    tabindex="-1"
    aria-labelledby="createRequisitionModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="createRequisitionModalLabel">
            Add Category
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label for="categoryName">Category Name</label>
            <input
              type="text"
              class="form-control"
              id="categoryName"
              placeholder="Enter category name"
              v-model="newCategoryName"
            />
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            :disabled="loading"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addCategory"
            :disabled="loading"
          >
            <span v-if="loading">
              <i class="spinner-border spinner-border-sm"></i> Saving...
            </span>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Modal -->
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
// import Pagination from "../components/pagination.vue";
// import Search from "../components/search.vue";
import BaseLayout from "../Patients/components/table_page_layout.vue";

export default {
  name: "itemcategories",
  components: { BaseLayout },

  data() {
    return {
      users: [],
      allData: {},
      apiLoading: true,
      tableLoading: true,
      placeHolderText: "Search category",
      newCategoryName: "",
      loading: false,
      searchUrl: "inventory/searchCompanyItemCategory",
      mainUrl: "inventory/getCompanyItemCategory",
    };
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    async handleSearch(searchTerm) {
      try {
        this.apiLoading = true;
        const url = "inventory/searchCompanyItemCategory";
        const body = { search_param: searchTerm };
        const rs = await generalApiRequest(url, "GET", body, 1);
        this.allData = rs;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
        this.apiLoading = false;
      }
    },

    handleContentChange(contents) {
      this.users = contents;
    },

    loaderSet(value) {
      if (value) this.users = [];
      this.tableLoading = value;
    },

    async callApi() {
      try {
        const url = "inventory/getCompanyItemCategory";
        const data = await generalApiRequest(url, "GET", {}, 1);
        this.allData = data;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
        this.apiLoading = false;
      }
    },

    async addCategory() {
      if (!this.newCategoryName.trim()) {
        alert("Please enter a category name.");
        return;
      }

      this.loading = true;
      try {
        const url = "inventory/addCompanyItemCategory";
        const body = { category_name: this.newCategoryName };
        const response = await generalApiRequest(url, "POST", body, 1);

        if (response.success || response.status === "success") {
          alert("Category added successfully.");
          this.newCategoryName = "";
          // const modal = bootstrap.Modal.getInstance(
          //   document.getElementById("createRequisitionModal")
          // );
          // modal.hide();
          this.callApi();
        } else {
          alert(response.message || "Failed to add category.");
        }
      } catch (error) {
        console.error("Error adding category:", error);
        alert("An error occurred while adding the category.");
      } finally {
        this.loading = false;
      }
    },
    async deleteCategory(id) {
      if (!confirm("Are you sure you want to delete this category?")) return;

      try {
        const url = "inventory/deleteCompanyItemCategory/" + id;
        const body = { id: id };
        const response = await generalApiRequest(url, "DELETE", body, 1);

        if (response.success || response.status === "success") {
          alert("Category deleted successfully.");

          // ✅ Remove the deleted item from local array
          this.users = this.users.filter((user) => user.id !== id);

          // Optionally also remove from allData if it holds same records
          if (this.allData.data) {
            this.allData.data = this.allData.data.filter(
              (item) => item.id !== id
            );
          }
        } else {
          alert(response.message || "Failed to delete category.");
        }
      } catch (error) {
        console.error("Error deleting category:", error);
        alert("An error occurred while deleting the category.");
      }
    },
    async deleteCategory_(id) {
      if (!confirm("Are you sure you want to delete this category?")) return;

      try {
        const url = "inventory/deleteCompanyItemCategory/" + id;
        const body = {};
        const response = await generalApiRequest(url, "GET", body, 1);

        if (response.success || response.status === "success") {
          alert("Category deleted successfully.");
          this.callApi();
        } else {
          alert(response.message || "Failed to delete category.");
        }
      } catch (error) {
        console.error("Error deleting category:", error);
        alert("An error occurred while deleting the category.");
      }
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
.top-actions {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}
</style>
